(function (window, document, globalName, iframeTagName, containerElement, iframeElement) {
    // add array index of for old browsers (IE<9)
    if (!Array.prototype.indexOf) {
        Array.prototype.indexOf = function (obj, start) {
            var i, j;
            i = start || 0;
            j = this.length;
            while (i < j) {
                if (this[i] === obj) {
                    return i;
                }
                i++;
            }
            return -1;
        };
    }
    // creates a global variable to delegate, so it will be available before script loaded
    window[globalName] = window[globalName] || {};

    window[globalName].createWidget = window[globalName].createWidget || function (parameters) {
        if (parameters.eventId && parameters.containerId) {
            containerElement = document.getElementById(parameters.containerId);
            if (containerElement) {
                iframeElement = document.createElement(iframeTagName);
                iframeElement.setAttribute('src', 'https://widget.zipeventapp.com/ticket/card/' + parameters.eventId + '?ref=' + window.encodeURIComponent(window.location.href));
                iframeElement.setAttribute('class', 'zipevent-widget-iframe');
                iframeElement.setAttribute('width', '100%');
                iframeElement.setAttribute('height', '100%');
                iframeElement.setAttribute('frameborder', '0');
                iframeElement.setAttribute('scrolling', 'auto');
                iframeElement.setAttribute('allowtransparency', 'true');

                // config height ***
                var height = 0;//
                var width = 0;//
                if (parameters['containerHeight']) height = parseInt(parameters.containerHeight);
                if (height < 500) height = 500;
                if (parameters['containerWidth']) width = parseInt(parameters.containerWidth);
                if (width < 450) width = 450;
                containerElement.style.height = `${height.toString()}px`;
                containerElement.style.height = `${width.toString()}px`;
                containerElement.appendChild(iframeElement);
            }
        }
    };
})(window, document, 'ZipeventWidget', 'iframe');
